var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
const Title = styled(Typography) `
  margin-bottom: 12px;
  font-weight: bold;
  ${({ theme }) => `
    color: ${theme.palette.primary.contrastText};
    filter: brightness(75%);
  `}
`;
const Container = styled.section `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0px;
  ${({ isInline }) => `
    width: ${isInline ? '100%' : 'auto'};
  `}
`;
const List = styled.ul `
  list-style-type: none;
  padding 0;
  margin: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ${({ isInline }) => `
    flex-direction: ${isInline ? 'row' : 'column'};
    justify-content: space-evenly;
    width: ${isInline ? '100%' : 'auto'};
  `}
`;
const Column = (_a) => {
    var { children, isInline = false, title } = _a, rest = __rest(_a, ["children", "isInline", "title"]);
    return (React.createElement(Container, Object.assign({ isInline: isInline }, rest),
        title && React.createElement(Title, null, title),
        children && React.createElement(List, { isInline: isInline }, children)));
};
Column.displayName = 'Footer.Column';
Column.propTypes = {
    children: PropTypes.node,
    isInline: PropTypes.bool,
    title: PropTypes.string,
};
const ColumnExtra = styled(Column) ``;
export default ColumnExtra;
